import axios from "axios";
import constants, { switchExternalNetwork } from "../plugins/const";

// Ya no es necesario definir manualmente baseURL aquí,
// lo lee dinámicamente de const.js, que ahora tiene la lógica de fallback.
const service = axios.create({
  baseURL: constants.BASEURL,
  // Sin timeout un request colgado (ej: SP bloqueado en BD) deja la pantalla
  // cargando indefinidamente; 150s acompaña al CommandTimeout del backend.
  timeout: 150000,
});

// Interceptor para actualizar el baseURL de cada petición en caso de que haya cambiado
service.interceptors.request.use(
  (config) => {
    config.baseURL = constants.BASEURL;
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para manejar el fallback automático cuando la red externa falla
service.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Verificamos si es un error de red (servidor caído, timeout, etc)
    const isNetworkError = !error.response || error.message === "Network Error" || error.code === "ECONNABORTED";

    // Verificamos si estamos en el entorno EXTERNO dinámicamente
    const isExternalEnvironment = constants.IS_EXTERNAL;

    if (isNetworkError && isExternalEnvironment && !originalRequest._retry) {
      originalRequest._retry = true;

      console.warn(`Fallo de conexión con: ${originalRequest.baseURL}. Intentando red alternativa...`);

      // Cambiamos a la siguiente red externa disponible (Bitel <-> Claro)
      switchExternalNetwork(originalRequest.baseURL);

      // Actualizamos la base URL de la instancia y de la petición actual
      service.defaults.baseURL = constants.BASEURL;
      originalRequest.baseURL = constants.BASEURL;

      // Reintentamos la petición con la nueva URL
      return service(originalRequest);
    }

    return Promise.reject(error);
  }
);

export default service;
